import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import SeoTitle from '@/components/SeoTitle';
import PageJsonLd from './components/PageJsonLd';
import HeroSection from './components/HeroSection';
import WhyDifferentApproach from './components/WhyDifferentApproach';
import ProfessionalPath from './components/ProfessionalPath';
import WhatClientGets from './components/WhatClientGets';
import WhyProgramsWork from './components/WhyProgramsWork';
import CaseStudiesSection from './components/CaseStudiesSection';
import IndustriesSection from './components/IndustriesSection';
import TrainingDirections from './components/TrainingDirections';
import PhilosophySection from './components/PhilosophySection';
import WhyBusinessTraining from './components/WhyBusinessTraining';
import FAQSection from './components/FAQSection';
import CTASection from './components/CTASection';

export default function AboutTrainerPage() {
  const navLinks = [
    { label: 'Подход', target: 'approach' },
    { label: 'Кейсы', target: 'cases' },
    { label: 'FAQ', target: 'faq' },
  ];

  return (
    <div className="min-h-screen bg-white font-['Inter']">
      
      <SeoTitle title="Бизнес-тренер Алексей Сивко | Business Training" />
      <PageJsonLd />
      <Navbar
        links={navLinks}
        ctaLabel="Заказать тренинг"
        ctaTarget="contact"
      />

      <HeroSection />
      <WhyDifferentApproach />
      <ProfessionalPath />
      <WhatClientGets />

      {/* CTA between sections */}
      <section className="py-12 bg-white">
        <div className="max-w-3xl mx-auto px-6 text-center">
          <div className="bg-teal-50 border border-teal-200 rounded-2xl p-6 md:p-8">
            <p className="text-lg md:text-xl text-teal-800 font-semibold mb-4">
              Готовы обсудить задачи вашей команды?
            </p>
            <button
              onClick={() => {
                const el = document.getElementById('contact');
                if (el) el.scrollIntoView({ behavior: 'smooth' });
              }}
              className="bg-teal-600 text-white px-6 py-3 rounded-lg text-sm font-semibold hover:bg-teal-700 transition-all transform hover:scale-105 whitespace-nowrap cursor-pointer inline-flex items-center gap-2"
            >
              Получить консультацию
              <i className="ri-arrow-right-line"></i>
            </button>
          </div>
        </div>
      </section>

      <WhyProgramsWork />
      <div id="cases"><CaseStudiesSection /></div>

      {/* CTA between sections */}
      <section className="py-12 bg-gray-50">
        <div className="max-w-3xl mx-auto px-6 text-center">
          <div className="bg-white border border-gray-200 rounded-2xl p-6 md:p-8 shadow-sm">
            <p className="text-lg md:text-xl text-gray-800 font-semibold mb-4">
              Хотите таких же результатов для своей компании?
            </p>
            <button
              onClick={() => {
                const el = document.getElementById('contact');
                if (el) el.scrollIntoView({ behavior: 'smooth' });
              }}
              className="bg-teal-600 text-white px-6 py-3 rounded-lg text-sm font-semibold hover:bg-teal-700 transition-all transform hover:scale-105 whitespace-nowrap cursor-pointer inline-flex items-center gap-2"
            >
              Обсудить задачу
              <i className="ri-chat-3-line"></i>
            </button>
          </div>
        </div>
      </section>

      <IndustriesSection />
      <TrainingDirections />
      <PhilosophySection />
      <WhyBusinessTraining />
      <FAQSection />
      <CTASection />

      <Footer />
    </div>
  );
}